
const API = {
    //category
    GET_LIST_CATEGORY_SEARCH :'/admin/categories/search' ,
    GET_LIST_CATEGORY: '/admin/categories',
    GET_DETAIL_CATEGORY: '/admin/categories',
    DELETE_CATEGORY: '/admin/categories',
    SAVE_CATEGORY: '/admin/categories',
    UPDATE_CATEGORY: '/admin/categories',
    UPLOAD_CATEGORY_IMAGE: '/admin/upload',

    //production
    GET_LIST_PRODUCT_SEARCH: '/admin/products/search',
    GET_LIST_PRODUCT: '/admin/products',
    GET_DETAIL_PRODUCT: '/admin/products',
    DELETE_PRODUCT: '/admin/products',
    SAVE_PRODUCT: '/admin/products',
    UPDATE_PRODUCT: '/admin/products',
    UPLOAD_PRODUCT_IMAGE: '/admin/upload',
    UPDATE_ORDER_PRODUCT: '/admin/products',
    // brand
    GET_LIST_BRAND: '/admin/brands',
    UPDATE_BRAND: '/admin/brands',
    SAVE_BRAND: 'admin/brands',
    DELETE_BRAND: '/admin/brands',
    UPLOAD_BRAND_IMAGE: '/admin/upload',
    GET_DETAIL_BRAND: '/admin/brands',
    //tag
    GET_LIST_TAG_SEARCH: '/admin/tags/search',
    GET_LIST_TAG: '/admin/tags',
    GET_DETAIL_TAG: '/admin/tags',
    SAVE_TAG: '/admin/tags',
    UPDATE_TAG: '/admin/tags',
    DELETE_TAG: '/admin/tags',
    UPLOAD_TAG_IMAGE: '/admin/upload',
    //attribute
    GET_LIST_ATTRIBUTE: '/admin/attributes',
    GET_DETAIL_ATTRIBUTE: '/admin/attributes',
    SAVE_ATTRIBUTE: '/admin/attributes',
    UPDATE_ATTRIBUTE: '/admin/attributes',
    DELETE_ATTRIBUTE: '/admin/attributes',

    //news
    GET_LIST_NEWS_SEARCH: '/admin/posts/search',
    GET_LIST_NEWS: '/admin/posts',
    GET_DETAIL_NEWS: '/admin/posts',
    DELETE_NEWS: '/admin/posts',
    UPLOAD_NEWS_IMAGE: '/admin/upload',
    SAVE_NEWS: '/admin/posts',
    UPDATE_NEWS: '/admin/posts',

    GET_LIST_CATEGORIES: '/admin/categoryPosts',

    //order
    GET_LIST_ORDER_SEARCH: '/admin/orders/search',
    GET_LIST_ORDER: '/admin/orders',
    GET_DETAIL_ORDER: '/admin/orders',
    SAVE_ORDER: '/admin/orders',
    UPDATE_ORDER: '/admin/orders',
    DELETE_ORDER: '/admin/orders',

    // seo
    GET_LIST_SEO : '/admin/checkSEOKeyword',
    
    //showroom
    GET_LIST_SHOWROOM: '/admin/stores',
    GET_DETAIL_SHOWROOM: '/admin/stores',
    SAVE_SHOWROOM: '/admin/stores',
    UPDATE_SHOWROOM: '/admin/stores',
    DELETE_SHOWROOM: '/admin/stores',
    UPLOAD_SHOWROOM_IMAGE: '/admin/upload',
    GET_LIST_STORE_SEARCH: '/admin/stores/search',
    UPDATE_ORDER_SHOWROOM: '/admin/stores',
    
    //warrantiesCenter
    GET_LIST_WARRANTIES_CENTER: '/admin/warrantiesCenter',
    GET_DETAIL_WARRANTIES_CENTER: '/admin/warrantiesCenter',
    SAVE_WARRANTIES_CENTER: '/admin/warrantiesCenter',
    UPDATE_WARRANTIES_CENTER: '/admin/warrantiesCenter',
    DELETE_WARRANTIES_CENTER: '/admin/warrantiesCenter',
    UPLOAD_WARRANTIES_CENTER_IMAGE: '/admin/upload',
    GET_LIST_WARRANTIES_CENTER_SEARCH: '/admin/warrantiesCenter/search',
    UPDATE_ORDER_WARRANTIES_CENTER: '/admin/warrantiesCenter',
    EXPORT_EXCEL_WARRANTY: '/admin/export/excel/warranty',
    
    //support
    GET_LIST_SUPPORT: '/admin/supports',
    GET_DETAIL_SUPPORT: '/admin/supports',
    GET_LIST_SUPPORT_SEARCH: '/admin/supports/search',
    SAVE_SUPPORT: '/admin/supports',
    UPDATE_SUPPORT: '/admin/supports',
    DELETE_SUPPORT: '/admin/supports',
    UPLOAD_AVATAR_SUPPORT: '/admin/upload',
    
    //user
    GET_LIST_USER: '/admin/users',
    GET_DETAIL_USER: '/admin/users',
    GET_LIST_SEARCH_USER: '/admin/users/search',
    SAVE_USER: '/admin/users',
    UPDATE_USER: '/admin/users',
    DELETE_USER: '/admin/users',
    CHANGE_PASSWORD_USER: '/admin/auth/change-password',
    
    //role
    GET_LIST_ROLE: '/admin/roles',
    GET_DETAIL_ROLE: '/admin/roles',
    GET_LIST_SEARCH_ROLE: '/admin/roles/search',
    SAVE_ROLE: '/admin/roles',
    UPDATE_ROLE: '/admin/roles',
    DELETE_ROLE: '/admin/roles',

    //permission
    GET_LIST_PERMISSION: '/admin/permissions',

    //config
        //banner
    GET_LIST_BANNER: '/admin/configPage/home/banner',
    GET_DETAIL_BANNER: '/admin/configPage/home/banner',
    DELETE_BANNER: '/admin/configPage/home/banner',
    SAVE_BANNER: '/admin/configPage/home/banner',
    UPDATE_BANNER: '/admin/configPage/home/banner',
    CHANGE_ACTIVE_BANNER: '/admin/configPage/home/banner',
    UPLOAD_BANNER_IMAGE: '/admin/upload',
        //product category
    GET_LIST_PRODUCT_CATEGORY: '/admin/configPage/home/productCategory',
    GET_DETAIL_PRODUCT_CATEGORY: '/admin/configPage/home/productCategory',
    DELETE_PRODUCT_CATEGORY: '/admin/configPage/home/productCategory',
    SAVE_PRODUCT_CATEGORY: '/admin/configPage/home/productCategory',
    UPDATE_PRODUCT_CATEGORY: '/admin/configPage/home/productCategory',
        //post
    GET_POST_CONFIGS: '/admin/configPage/home/post',
    UPDATE_POST_CONFIGS: '/admin/configPage/home/post',
        //news
    GET_NEW_POST_CONFIGS: '/admin/configPage/new/post',
    GET_DETAIL_NEW_POST_CONFIGS: '/admin/configPage/new/post',
    UPDATE_DETAIL_NEW_POST_CONFIGS: '/admin/configPage/new/post',
    DELETE_DETAIL_NEW_POST_CONFIGS: '/admin/configPage/new/post',
    GET_NEW_POST_CONFIGS_SIDEBAR: '/admin/configPage/new/sidebar',
    UPDATE_NEW_POST_CONFIGS_SIDEBAR: '/admin/configPage/new',
        // config blanco
    GET_LIST_CONFIG_BLANCO: '/admin/configPage/blanco/content',
    UPDATE_LIST_CONFIG_BLANCO: '/admin/configPage/blanco',
    UPLOAD_BLANCO_IMAGE: '/admin/upload',
        // config bosch
    GET_LIST_CONFIG_BOSCH: '/admin/configPage/bosch/content',
    UPDATE_LIST_CONFIG_BOSCH: '/admin/configPage/bosch',
    // config bosch
    GET_LIST_CONFIG_BLUM: '/admin/configPage/blum/content',
    UPDATE_LIST_CONFIG_BLUM: '/admin/configPage/blum',
    // config bosch
    GET_LIST_CONFIG_WMF: '/admin/configPage/wmf/content',
    UPDATE_LIST_CONFIG_WMF: '/admin/configPage/wmf',
    UPLOAD_WMF_IMAGE: '/admin/upload',
    // config finsh
    GET_LIST_CONFIG_FINISH: '/admin/configPage/finish/content',
    UPDATE_LIST_CONFIG_FINISH: '/admin/configPage/finish',
    //config advise
    GET_LIST_CONFIG_ADVISE:'/admin/configPage/advice/content',
    UPDATE_LIST_CONFIG_ADVISE: '/admin/configPage/advice',
    UPLOAD_ADVISE_IMAGE: '/admin/upload',
    //config renew
    GET_LIST_CONFIG_RENEW:'/admin/configPage/thuCuDoiMoi/content',
    UPDATE_LIST_CONFIG_RENEW: '/admin/configPage/thuCuDoiMoi',
    UPLOAD_RENEW_IMAGE: '/admin/upload',
    // category post
    GET_LIST_CATEGORY_POST_SEARCH :'/admin/categoryPosts/search' ,
    GET_LIST_CATEGORY_POST: '/admin/categoryPosts',
    GET_DETAIL_CATEGORY_POST: '/admin/categoryPosts',
    DELETE_CATEGORY_POST: '/admin/categoryPosts',
    SAVE_CATEGORY_POST: '/admin/categoryPosts',
    UPDATE_CATEGORY_POST: '/admin/categoryPosts',


    // promotion_gift
        // promotion
    GET_LIST_RULES : '/admin/rules',
    DELETE_RULES : '/admin/rules',
    SAVE_RULES : '/admin/rules',
    GET_DETAIL_RULES: '/admin/rules',
    UPDATE_RULES : '/admin/rules',

        //gift
            // list gift
    GET_LIST_PROMOTIONS : '/admin/promotions',
    DELETE_PROMOTIONS : '/admin/promotions',
    SAVE_PROMOTIONS : '/admin/promotions',
    GET_DETAIL_PROMOTIONS: '/admin/promotions',
    UPDATE_PROMOTIONS : '/admin/promotions',
            // packages gift
    GET_LIST_PACKAGES : '/admin/packages',
    DELETE_PACKAGES : '/admin/packages',
    SAVE_PACKAGES : '/admin/packages',
    GET_DETAIL_PACKAGES: '/admin/packages',
    UPDATE_PACKAGES : '/admin/packages',


    //warranty
    GET_LIST_WARRANTY: '/admin/warranties',
    GET_DETAIL_WARRANTY: '/admin/warranties',
    DELETE_WARRANTY: '/admin/warranties',
    SAVE_WARRANTY: '/admin/warranties',
    UPDATE_WARRANTY: '/admin/warranties',
    GET_LIST_WARRANTY_SEARCH:'/admin/warranties/search',
    //product error
    GET_LIST_PRODUCT_ERROR: '/admin/productErrorReports',
    GET_DETAIL_PRODUCT_ERROR: '/admin/productErrorReports',
    DELETE_PRODUCT_ERROR: '/admin/productErrorReports',
    SAVE_PRODUCT_ERROR: '/admin/productErrorReports',
    UPDATE_PRODUCT_ERROR: '/admin/productErrorReports',
    GET_LIST_PRODUCT_ERROR_SEARCH: '/admin/productErrorReports/search',
    //comments
    GET_LIST_COMMENT_SEARCH: '/admin/productComments/search',
    GET_LIST_COMMENT: '/admin/productComments',
    GET_DETAIL_COMMENT: '/admin/productComments',
    DELETE_COMMENT: '/admin/productComments',
    SAVE_COMMENT: '/admin/productComments',
    UPDATE_COMMENT: '/admin/productComments',
    UPLOAD_COMMENT_IMAGE:'/admin/upload',
    //advise
    GET_LIST_ADVISE: '/admin/advices',
    GET_DETAIL_ADVISE: '/admin/advices',
    DELETE_ADVISE: '/admin/advices',
    SAVE_ADVISE: '/admin/advices',
    UPDATE_ADVISE: '/admin/advices',
    GET_LIST_ADVISE_SEARCH: '/admin/advices/search',

    /* manage renew*/
    GET_LIST_RENEW: '/admin/thuCuDoiMoi',
    GET_DETAIL_RENEW: '/admin/thuCuDoiMoi',
    DELETE_RENEW: '/admin/thuCuDoiMoi',
    SAVE_RENEW: '/admin/thuCuDoiMoi',
    UPDATE_RENEW: '/admin/thuCuDoiMoi',
    GET_LIST_RENEW_SEARCH: '/admin/thuCuDoiMoi/search',
    //about
    GET_CONFIG_ABOUT: '/admin/configPage/about/content',
    UPDATE_CONFIG_ABOUT: '/admin/configPage/about',

    //menu left
    CONFIG_MENU_LEFT: '/admin/configPage/menu/left',
    UPDATE_CONFIG_MENU_LEFT_HIDDEN: '/admin/configPage/menu/hidden',
    // GET_CONFIG_MENU_LEFT: '/admin/configPage/menu/left',
    // SAVE_CONFIG_MENU_LEFT: '/admin/configPage/menu/left',
    // UPDATE_CONFIG_MENU_LEFT: '/admin/configPage/menu/left',

    //wards
    GET_DATA_SEARCH_REGION: '/admin/wards/search',

    //import excel
    IMPORT_EXCEL_SHOWROOM: '/admin/import/excel/showroom',
    IMPORT_EXCEL_WARRANTY: '/admin/import/excel/warranty',
    IMPORT_EXCEL_WARRANTIES_CENTER: '/admin/import/excel/warrantiesCenter',
    EXPORT_EXCEL_SHOWROOM: '/admin/export/excel/showroom',
    
    // config accessory
    GET_CONFIG_ACCESSORY: '/admin/configPage/accessory/content',
    UPDATE_CONFIG_ACCESSORY: '/admin/configPage/accessory',

    // config whybuy
    GET_CONFIG_WHYBUY: '/admin/configPage/whybuy/content',
    UPDATE_CONFIG_WHYBUY: '/admin/configPage/whybuy',

    // config showroom
    GET_CONFIG_SHOWROOM: '/admin/configPage/showroom/content',
    UPDATE_CONFIG_SHOWROOM: '/admin/configPage/showroom',

    // config footer
    GET_CONFIG_FOOTER: '/admin/configPage/footer/content',
    UPDATE_CONFIG_FOOTER: '/admin/configPage/footer',
    
    // upload image
    UPLOAD_IMAGE: '/admin/upload',

    //config showroom
    DETAIL_CONFIG_SHOWROOM: '/admin/configPage/showroom/type',
    UPDATE_CONFIG_TYPE_SHOWROOM: '/admin/configPage/showroom/type',

    //config showroom link
    GET_CONFIG_SHOWROOM_LINK: '/admin/configPage/showroom/link',
    UPDATE_CONFIG_SHOWROOM_LINK: '/admin/configPage/showroom/link'
}
export default  API